import {
    call, put, all, takeEvery
} from 'redux-saga/effects';
import fileDownload from 'js-file-download';
import * as actions from './actions';
import * as downloadCrifApi from '../../../api/downloadCrifApi';

export function* createBrowserDownload(fd, action) {
    yield call(fd, action.response.data, action.response.filename || `CRIF ${action.csa} ${action.date}.txt`);
}

export function* downloadCrif(api, action) {
    try {
        const downloadResponse = yield call(api.downloadCrif, action.date, action.csa);
        yield put(actions.downloadCrifSucceeded(action.date, action.csa, downloadResponse));
    } catch (error) {
        yield put(actions.downloadCrifFailed(error.message));
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.DOWNLOAD_CRIF_REQUESTED, downloadCrif, downloadCrifApi),
        takeEvery(actions.DOWNLOAD_CRIF_SUCCEEDED, createBrowserDownload, fileDownload)
    ]);
}
